import React, { useState, useEffect } from 'react';

/**
 * TypingRotator — types out words from a list, deletes, types next.
 * Used in hero to cycle through AI service types.
 */
const TypingRotator = ({
  words = [],
  typingSpeed = 90,
  deletingSpeed = 45,
  pauseAfterTyped = 1600,
  pauseAfterDeleted = 220,
  className = '',
}) => {
  const [text, setText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!words.length) return;
    const currentWord = words[wordIndex % words.length];

    let delay;
    if (!isDeleting && text === currentWord) {
      delay = pauseAfterTyped;
    } else if (isDeleting && text === '') {
      delay = pauseAfterDeleted;
    } else if (isDeleting) {
      delay = deletingSpeed;
    } else {
      delay = typingSpeed + Math.random() * 30;
    }

    const t = setTimeout(() => {
      if (!isDeleting && text === currentWord) {
        setIsDeleting(true);
      } else if (isDeleting && text === '') {
        setIsDeleting(false);
        setWordIndex((i) => i + 1);
      } else if (isDeleting) {
        setText(currentWord.substring(0, text.length - 1));
      } else {
        setText(currentWord.substring(0, text.length + 1));
      }
    }, delay);

    return () => clearTimeout(t);
  }, [text, isDeleting, wordIndex, words, typingSpeed, deletingSpeed, pauseAfterTyped, pauseAfterDeleted]);

  return (
    <span className={className} data-testid="typing-rotator">
      {text}
      <span
        className="inline-block w-[3px] h-[0.85em] bg-[#FF6B00] ml-1 align-middle"
        style={{ animation: 'blink-caret 1s steps(2, start) infinite' }}
        aria-hidden="true"
      />
      <style>{`
        @keyframes blink-caret { 50% { opacity: 0; } }
      `}</style>
    </span>
  );
};

export default TypingRotator;
